import { colord, extend } from 'colord';
import namesPlugin from 'colord/plugins/names';
extend([namesPlugin]);

export const colorMixin = {
    methods: {
        isColorLight(color) {
            return colord(colord(color).toHex()).isLight();
        },
        isColorDark(color) {
            return colord(colord(color).toHex()).isDark();
        },
    },
};
